import { render, staticRenderFns } from "./PostcodeAccordion.vue?vue&type=template&id=73b4f20e&scoped=true&"
import script from "./PostcodeAccordion.vue?vue&type=script&lang=js&"
export * from "./PostcodeAccordion.vue?vue&type=script&lang=js&"
import style0 from "./PostcodeAccordion.vue?vue&type=style&index=0&id=73b4f20e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73b4f20e",
  null
  
)

export default component.exports